import { TApplicationState } from '../types/redux';
import { ETargetPage } from '../types/page';

const selectPage = (state: TApplicationState) => {
  return state.page;
};

export const selectSource = (state: TApplicationState): string => {
  const page = selectPage(state);

  return page.source ?? '';
};

export const selectTargetPage = (state: TApplicationState): ETargetPage => {
  const page = selectPage(state);

  return (page.targetPage as ETargetPage) ?? ETargetPage.myHomePage;
};
